import { render, staticRenderFns } from "./tablo.vue?vue&type=template&id=5b47bf9a&scoped=true"
import script from "./tablo.vue?vue&type=script&lang=js"
export * from "./tablo.vue?vue&type=script&lang=js"
import style0 from "./tablo.vue?vue&type=style&index=0&id=5b47bf9a&prod&lang=scss&scoped=true"
import style1 from "./tablo.vue?vue&type=style&index=1&id=5b47bf9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b47bf9a",
  null
  
)

export default component.exports